import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {FlexLayoutModule} from '@ngbracket/ngx-layout';
import {EonUiComponentsAngularModule} from '@eon-ui/eon-ui-components-angular';
import {MaterialModule} from './material.module';
import {HttpClientModule} from "@angular/common/http";

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    RouterModule,
    FlexLayoutModule,
    EonUiComponentsAngularModule,
    MaterialModule,
  ],
  exports: [
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    RouterModule,
    FlexLayoutModule,
    EonUiComponentsAngularModule,
    MaterialModule
  ],
})
export class SharedModule {
}
